<template>
  <v-container>
    <v-card flat max-width="100%">
      <v-card-title class="text-h5">{{ $t('drawerPage.systemSettingsLabel') }}</v-card-title>
      <v-tabs show-arrows next-icon="fas fa-arrow-right" prev-icon="fas fa-arrow-left">
        <v-tab>{{ $t('settingsPage.settingsLabel') }}</v-tab>
        <v-tab>{{ $t('settingsPage.customerSettings') }}</v-tab>
        <v-tab>{{ $t('settingsPage.mainMenu') }}</v-tab>
        <v-tab>{{ $t('settingsPage.configurationSettingsTabLabel') }}</v-tab>
        <v-tab>{{ $t('settingsPage.labelLabel') }}</v-tab>
        <v-tab>{{ $t('settingsPage.offerStructureTabLabel') }}</v-tab>
        <v-tab>{{ $t('settingsPage.billingTabLabel') }}</v-tab>
        <v-tab>{{ $t('settingsPage.apiKeys') }}</v-tab>
        <v-tab>{{ $t('settingsPage.landingPageTab') }}</v-tab>

        <v-tab-item>
          <general-settings-page></general-settings-page>
        </v-tab-item>
        <v-tab-item>
          <customer-settings></customer-settings>
        </v-tab-item>
        <v-tab-item>
          <main-menu-page></main-menu-page>
        </v-tab-item>
        <v-tab-item>
          <configuration-settings></configuration-settings>
        </v-tab-item>
        <v-tab-item>
          <tag-page></tag-page>
        </v-tab-item>
        <v-tab-item>
          <offer-structure-page></offer-structure-page>
        </v-tab-item>
        <v-tab-item>
          <billing-page></billing-page>
        </v-tab-item>
        <v-tab-item>
          <api-key-page></api-key-page>
        </v-tab-item>
        <v-tab-item>
          <landing-page-settings></landing-page-settings>
        </v-tab-item>
      </v-tabs>
    </v-card>
  </v-container>
</template>

<script lang="ts">
import Vue from 'vue'
import {Component} from "vue-property-decorator";
import BillingPage from "@/pages/settings/BillingTab.vue";
import OfferStructurePage from "@/pages/settings/OfferStructureTab.vue";
import TagPage from "@/pages/settings/TagPage.vue";
import ApiKeyPage from "@/pages/settings/ApiKeyPage.vue";
import GeneralSettingsPage from "@/pages/settings/GeneralSettingsPage.vue";
import ConfigurationSettings from "@/pages/settings/ConfigurationSettings.vue";
import MainMenuPage from "@/pages/settings/MainMenuPage.vue";
import CustomerSettings from "@/pages/settings/CustomerSettings.vue";
import LandingPageSettings from "@/pages/settings/LandingPageSettings.vue";

@Component({
  components: {
    BillingPage,
    OfferStructurePage,
    TagPage,
    ApiKeyPage,
    GeneralSettingsPage,
    ConfigurationSettings,
    MainMenuPage,
    CustomerSettings,
    LandingPageSettings
  }
})

export default class SettingsPage extends Vue {

}
</script>

<style lang="stylus" scoped>

</style>
